import React from 'react';
import LegalDoc from '../components/LegalDoc';

/* Kullanım Koşulları — çatı şirket düzeyi genel yazılım sözleşmesi.
   İçerik `translations[lang].terms` içinde; kabuk LegalDoc'ta. */
export default function TermsPage() {
  return <LegalDoc sozlukAnahtari="terms" parlaklikRengi="rgba(6, 182, 212, 0.3)" />;
}
